import type { components } from '@/api/schema';
import i18n from '@/i18n';

type TicketMessage = components['schemas']['TicketMessageResource'];

const ROLE_CODES = ['owner', 'manager', 'cashier', 'viewer'];
const roleLabel = (role: string): string => ROLE_CODES.includes(role) ? i18n.t(`tick_sender.roles.${role}`) : role;

/** Chat label as Lovable's TicketDetail: «name · role · merchant» or «name · Admin». */
export function ticketSenderLabel(msg: TicketMessage): string {
  const parts = [msg.sender?.name || i18n.t('tick_sender.unknown')];
  if (msg.sender?.is_platform_admin) return [...parts, i18n.t('tick_sender.admin')].join(' · ');
  if (msg.sender_role) parts.push(roleLabel(msg.sender_role));
  if (msg.sender_merchant_name) parts.push(msg.sender_merchant_name);
  return parts.join(' · ');
}
